<label *ngIf="label" [class.required]="form.get(controlName)?.hasValidator(Validators.required)" class="form-label">
  {{ label }}
</label>

<p-dropdown [placeholder]="placeholder" [options]="options" [optionLabel]="optionLabel" [optionValue]="optionValue"
  [(ngModel)]="selectedOption" (ngModelChange)="onSelectedOptionChange()" [autoDisplayFirst]="autoDisplayFirst"
  [disabled]="disabled" appendTo="body">
  §
</p-dropdown>

<div class="result" *ngIf="rangeDates?.[0] && rangeDates?.[1]">
  <span>{{rangeDates?.[0] | formattedDate}}</span> -
  <span>{{rangeDates?.[1] | formattedDate}}</span>
</div>